import React, { useState, useEffect } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import Grid from '@mui/material/Grid2';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useFielderSnackBar } from '~/FielderElements/useFielderSnackBar';

const SmartUserTableFilter = (
	{
		showFilter, changeFilterState, totalNumber, showDisabled, showMessageNoData,
		lan = {}, noDataTextActive, noDataTextDisable, onChange, onSearch, onReset
	}) => {
	const [text, setText] = useState('');
	const fielderMsg = useFielderSnackBar();
	useEffect(() => {
		if (!showMessageNoData) return;
		/*if (!showFilter && !changeFilterState && totalNumber === 0) {
			const msg = showDisabled ? noDataTextDisable : noDataTextActive;
			if (msg) fielderMsg({
				message: msg, variant: 'warning', closeButton: true, duration: 4000 });
		}*/
		if (showFilter && changeFilterState && totalNumber === 0 && lan.noDataFilter) {
			fielderMsg({
				message: lan.noDataFilter, variant: 'warning', closeButton: true, duration: 4000 });
		}
	}, [
		showFilter, changeFilterState, totalNumber, showDisabled,
		showMessageNoData, lan, noDataTextActive, noDataTextDisable
	]);
	const handleChange = (e) => {
		const value = e.target.value;
		setText(value);
		onChange?.(value);
	};
	const handleSearch = () => {
		onSearch?.();
	};
	const handleReset = () => {
		setText('');
		onReset?.();
	};
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') handleSearch();
	};
	return (
		<>
			{showFilter && (
				<Grid container direction='row' justifyContent='flex-end'>
					<Grid size={'auto'}>
						<TextField
							id='tf-filter'
							fullWidth
							size='small'
							value={text}
							onChange={handleChange}
							onKeyDown={handleKeyDown}
							slotProps={{
								input: {
									endAdornment: (
										<InputAdornment position='end'>
											{text && (
												<IconButton size='small' onClick={handleReset}><CloseIcon /></IconButton>
											)}
											<IconButton size='small' onClick={handleSearch}><SearchIcon /></IconButton>
										</InputAdornment>
									),
								},
							}}
						/>
					</Grid>
				</Grid>
			)}
		</>
	);
};
export default SmartUserTableFilter;
